import { _, removeClasses } from '../utils.js'
import config from '../config/main.js'

class Menu {
    constructor() {
        this.menu = _('menu').node()
        this.menuItem = _('menu-item', 'element').nodes()
        this.menuUnFocus = _('menu-unfocus', 'element-2').nodes()
        this.menuLink = _('menu-link', 'element').nodes()
        this.subTrigger = _('sub-trigger', 'element').nodes()
        this.backTrigger = _('back-trigger', 'element').nodes()
        this.classes = {
            menuItemActive: 'nav__item--active',
        }

        this.navTabletBreak = window.matchMedia('(max-width: 1025px)')
        this.navMobileBreak = window.matchMedia(
            `(max-width: ${config.breakpoint.small}px)`,
        )

        this.toggleNavFunctionality()
        this.navMobileBreak.addListener(this.toggleNavFunctionality)
        this.navTabletBreak.addListener(this.toggleNavFunctionality)

        this.subTrigger.map((el) => {
            el.addEventListener('click', this.addActiveClass)
        })
        this.backTrigger.map((el) => {
            el.addEventListener('click', this.removeActiveClass)
        })
    }

    toggleNavFunctionality = () => {
        let device = 'desktop'
        const isTouch = 'ontouchstart' in document.documentElement

        if (this.navMobileBreak.matches) {
            device = 'mobile'
        }
        if (!this.navMobileBreak.matches && isTouch) {
            device = 'tablet'
        }
        switch (device) {
            case 'mobile':
                this.removeTabAccessibility()
                this.removeTapStoppers()
                break
            case 'tablet':
                this.addTapStoppers()
                break
            case 'desktop':
                this.removeTapStoppers()
                this.addTabAccessibility()
                break
            default:
                console.warn('no device detected')
        }
    }

    addTabAccessibility = () => {
        this.menuLink.map((el) => {
            el.addEventListener('focus', this.addActiveClass)
        })
        this.menuUnFocus.map((el) => {
            el.addEventListener('focus', this.removeActiveClassAccessibility)
        })
    }

    removeTabAccessibility = () => {
        this.menuLink.map((el) => {
            el.removeEventListener('focus', this.addActiveClass)
        })
        this.menuUnFocus.map((el) => {
            el.removeEventListener('focus', this.removeActiveClassAccessibility)
        })
    }

    addTapStoppers = () => {
        this.menuLink.map((el) => {
            el.addEventListener('click', this.preventFirstTap)
        })
    }

    removeTapStoppers = () => {
        this.menuLink.map((el) => {
            el.removeEventListener('click', this.preventFirstTap)
        })
    }

    preventFirstTap = (e) => {
        e.preventDefault()
        this.addTapStoppers()
        e.currentTarget.removeEventListener('click', this.preventFirstTap)
    }

    addActiveClass = (e) => {
        e.currentTarget
            .closest(_('menu-item', 'element').str())
            .classList.add(this.classes.menuItemActive)
    }

    removeActiveClassAccessibility = () => {
        removeClasses(this.menuItem, this.classes.menuItemActive)
    }

    removeActiveClass = (e) => {
        e.currentTarget
            .closest(_('menu-item', 'element').str())
            .classList.remove(this.classes.menuItemActive)
    }
}

export default Menu
